import React from 'react';
import { FormInput, InlineEditColumnProps, Button, Form, Row, FormResetButton, Col } from '@digital/ui';
import { Icon, Tooltip, Table } from 'antd';
import { RegistroEsin204 } from '../../api/esin204';
import { compareText, compareTypeNumber, compareDates, compareBool } from '@app/helpers/comparators';
import { newGuid } from '@app/helpers/generatorGuid';

interface Registrosrop {
    result: RegistroEsin204[];
    tabelaId: string;
}

const larguraCodigoPacote = 70;
const larguraNumOi = 50;
const larguraParaOi = 70
const larguraItemEDescricao = 300;
const larguraStatusProcessamento = 150;
const larguraUn = 20;
const larguraMovimento = 70;
const larguraEsp = 50;
const larguraTipo = 50;
const larguraSerie = 50;
const larguraDocumento = 50;
const larguraFornecedorNumero = 50;
const larguraFornecedorNome = 70;
const larguraFornecedorMRN = 100;
const larguraNatOper = 50;
const larguraQuantidade = 50;
const larguraValorTotal = 70;
const larguraValorDolar = 70;
const larguraOrdemCompra = 70;
const larguraContratoPcs = 70;
const larguraIcmsValor = 50;
const larguraIcmsPercentual = 50;
const larguraAprop = 70;
const larguraNarrativa = 300;
const larguraRecass = 40;
const larguraVrp = 40;
const larguraDesconsiderarExecutado = 40;
const larguraMotivo = 300;

const larguraTotal = () => {
    return larguraCodigoPacote +
        larguraNumOi +
        larguraParaOi +
        larguraItemEDescricao +
        larguraStatusProcessamento +
        larguraUn +
        larguraMovimento +
        larguraEsp +
        larguraTipo +
        larguraSerie +
        larguraDocumento +
        larguraFornecedorNumero +
        larguraFornecedorNome +
        larguraFornecedorMRN +
        larguraNatOper +
        larguraQuantidade +
        larguraValorTotal +
        larguraValorDolar +
        larguraOrdemCompra +
        larguraContratoPcs +
        larguraIcmsValor +
        larguraIcmsPercentual +
        larguraAprop +
        larguraNarrativa +
        larguraRecass +
        larguraVrp +
        larguraDesconsiderarExecutado +
        larguraMotivo + 1300
};


const TabelaExecutadoMesAno = (props: Registrosrop) => {
    const { result, tabelaId } = props;
    const columnsProcessado: InlineEditColumnProps<RegistroEsin204>[] = [
        {
            title: 'Status',
            dataIndex: 'statusProcessoConsolidarExecutado',
            width: larguraStatusProcessamento,
            align: 'center',
            render(text, record, index) {
                return <Tooltip title={`${record.statusProcessoConsolidarExecutadoDescricao}`}>{record.mensagemProcessoConsolidarExecutado} </Tooltip>;
            },
            sorter: (a, b) => compareBool(a.statusProcessoConsolidarExecutado, b.statusProcessoConsolidarExecutado),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Status Processo Executado"
                            name="statusProcessoConsolidarExecutadoDescricao"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.statusProcessoConsolidarExecutadoDescricao !== undefined &&
                record.statusProcessoConsolidarExecutadoDescricao
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'Cod Pacote',
            dataIndex: 'codigoPacote',
            width: larguraCodigoPacote,
            align: 'center',
            sorter: (a, b) => compareText(a.codigoPacote, b.codigoPacote),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Cod Pacote"
                            name="codigoPacote"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.codigoPacote !== undefined &&
                record.codigoPacote
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'NUM. OI',
            dataIndex: 'numOi',
            sorter: (a, b) => compareText(a.numOi, b.numOi),
            width: larguraNumOi,
            align: 'center',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar NUM. OI"
                            name="numOi"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.numOi !== undefined &&
                record.numOi
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),

        },
        {
            title: 'PARA OI',
            dataIndex: 'paraOi',
            width: larguraParaOi,
            sorter: (a, b) => compareTypeNumber(a.paraOi, b.paraOi),
            align: 'center',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar PARA OI"
                            name="paraOi"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.paraOi !== undefined &&
                record.paraOi
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'ITEM E DESCRIÇÃO',
            dataIndex: 'itemEDescricao',
            sorter: (a, b) => compareText(a.itemEDescricao, b.itemEDescricao),
            width: larguraItemEDescricao,
            render(text, record, index) {
                return <Tooltip title={`${record.itemEDescricao}`}>{record.itemEDescricao ? record.itemEDescricao.substring(0, 40) : ''} </Tooltip>;
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar ITEM E DESCRIÇÃO"
                            name="itemEDescricao"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.itemEDescricao !== undefined &&
                record.itemEDescricao
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'UN',
            dataIndex: 'un',
            width: larguraUn,
            sorter: (a, b) => compareText(a.un, b.un),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Unidade"
                            name="un"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.un !== undefined &&
                record.un
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'MOVIMENTO',
            dataIndex: 'movimentoDateFormat',
            width: larguraMovimento,
            align: 'center',
            sorter: (a, b) => compareDates(a.movimentoDateFormat, b.movimentoDateFormat),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar MOVIMENTO"
                            name="movimentoDateFormat"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.movimentoDateFormat !== undefined &&
                record.movimentoDateFormat
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'ESP',
            dataIndex: 'esp',
            align: 'center',
            width: larguraEsp,
            sorter: (a, b) => compareText(a.esp, b.esp),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar ESP"
                            name="esp"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.esp !== undefined &&
                record.esp
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'TIPO',
            dataIndex: 'tipo',
            align: 'center',
            width: larguraTipo,
            sorter: (a, b) => compareText(a.tipo, b.tipo),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Tipo"
                            name="tipo"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.tipo !== undefined &&
                record.tipo
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'SÉRIE',
            dataIndex: 'serie',
            align: 'center',
            width: larguraSerie,
            sorter: (a, b) => compareText(a.serie, b.serie),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar SÉRIE"
                            name="serie"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.serie !== undefined &&
                record.serie
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'DOCUMENTO',
            dataIndex: 'documento',
            align: 'center',
            width: larguraDocumento,
            sorter: (a, b) => compareText(a.documento, b.documento),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar DOCUMENTO"
                            name="documento"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.documento !== undefined &&
                record.documento
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'FORNECEDOR',
            children: [
                {
                    title: 'NÚMERO',
                    dataIndex: 'fornecedor',
                    width: larguraFornecedorNumero,
                    sorter: (a, b) => compareText(a.fornecedor, b.fornecedor),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar Fornecedor Número"
                                    name="fornecedor"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.fornecedor !== undefined &&
                        record.fornecedor
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'NOME',
                    dataIndex: 'nomeFornecedor',
                    width: larguraFornecedorNome,
                    sorter: (a, b) => compareText(a.nomeFornecedor, b.nomeFornecedor),
                    render(text, record, index) {
                        return <>{record.nomeFornecedor ? record.nomeFornecedor.substring(0, 20) : ''} </>;
                    },
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar Nome Fornecedor"
                                    name="nomeFornecedor"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.nomeFornecedor !== undefined &&
                        record.nomeFornecedor
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'MRN',
                    dataIndex: 'fornecedorMrnDescricao',
                    sorter: (a, b) => compareText(a.fornecedorMrnDescricao, b.fornecedorMrnDescricao),
                    width: larguraFornecedorMRN,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar Fornecedor"
                                    name="fornecedorMrnDescricao"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.fornecedorMrnDescricao !== undefined &&
                        record.fornecedorMrnDescricao
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
            ]
        },
        {
            title: 'NAT OPER',
            dataIndex: 'natOper',
            width: larguraNatOper,
            sorter: (a, b) => compareText(a.natOper, b.natOper),
            align: 'center',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar NAT OPER"
                            name="natOper"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.natOper !== undefined &&
                record.natOper
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'QUANTIDADE',
            dataIndex: 'quantidade',
            width: larguraQuantidade,
            sorter: (a, b) => compareText(a.quantidade, b.quantidade),
            align: 'center',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar QUANTIDADE"
                            name="quantidade"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.quantidade !== undefined &&
                record.quantidade
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'VALOR',
            align: 'center',
            children: [
                {
                    title: 'TOTAL',
                    dataIndex: 'vlrTotal',
                    width: larguraValorTotal,
                    sorter: (a, b) => compareText(a.vlrTotal, b.vlrTotal),
                    align: 'right',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar Valor TOTAL"
                                    name="vlrTotal"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.vlrTotal !== undefined &&
                        record.vlrTotal
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'DOLAR',
                    dataIndex: 'vlMarDolar',
                    width: larguraValorDolar,
                    sorter: (a, b) => compareText(a.vlMarDolar, b.vlMarDolar),
                    align: 'right',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar DOLAR"
                                    name="vlMarDolar"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.vlMarDolar !== undefined &&
                        record.vlMarDolar
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                }
            ]
        },
        {
            title: 'ORDEM COMPRA',
            width: larguraOrdemCompra,
            dataIndex: 'ordemCompra',
            sorter: (a, b) => compareTypeNumber(a.ordemCompra, b.ordemCompra),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar ORDEM COMPRA"
                            name="ordemCompra"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.ordemCompra !== undefined &&
                record.ordemCompra
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'Contrato/PCs',
            dataIndex: 'contratoPcs',
            width: larguraContratoPcs,
            sorter: (a, b) => {
                return compareTypeNumber(a.contratoPcs, b.contratoPcs)
            },
            align: 'center',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Contrato/PCs"
                            name="contratoPcs"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) => {
                try {
                    if (record != undefined
                        && record.hasOwnProperty('contratoPcs')
                        && record.contratoPcs != null) {
                        return record.contratoPcs
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase())
                    }
                } catch (e) {
                }
                return false;
            }
        },
        {
            title: 'ICMS',
            children: [
                {
                    title: 'VALOR',
                    dataIndex: 'icms',
                    align: 'right',
                    width: larguraIcmsValor,
                    sorter: (a, b) => compareText(a.icms, b.icms),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar ICMS"
                                    name="icms"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.icms !== undefined &&
                        record.icms
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: '%',
                    dataIndex: 'icmsPorcentagem',
                    align: 'center',
                    width: larguraIcmsPercentual,
                    sorter: (a, b) => compareText(a.icmsPorcentagem, b.icmsPorcentagem),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar ICMS%"
                                    name="icmsPorcentagem"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.icmsPorcentagem !== undefined &&
                        record.icmsPorcentagem
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
            ]
        },
        {
            title: 'APROP',
            dataIndex: 'aprop',
            width: larguraAprop,
            sorter: (a, b) => compareText(a.aprop, b.aprop),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar APROP"
                            name="aprop"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.aprop !== undefined &&
                record.aprop
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'NARRATIVA',
            dataIndex: 'narrativa',
            width: larguraNarrativa,
            sorter: (a, b) => compareText(a.narrativa, b.narrativa),
            render(text, record, index) {
                return <>{record.narrativa ? record.narrativa.substring(0, 40) : ''} </>;
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar NARRATIVA"
                            name="narrativa"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.narrativa !== undefined &&
                record.narrativa
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'RECLASS',
            dataIndex: 'reclassificacaoProximoMes',
            width: larguraRecass,
            sorter: (a, b) => compareBool(a.reclassificacaoProximoMes, b.reclassificacaoProximoMes),
            align: 'center',
            render(text, record, index) {
                return <>{tratarValoresBoolean(record.reclassificacaoProximoMes)} </>;
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar RECLASS"
                            name="reclassificacaoProximoMes"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.reclassificacaoProximoMes !== undefined &&
                record.reclassificacaoProximoMes
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),

        },
        {
            title: 'VRP',
            dataIndex: 'verbaRemanescenteProvisao',
            width: larguraVrp,
            align: 'center',
            sorter: (a, b) => compareBool(a.verbaRemanescenteProvisao, b.verbaRemanescenteProvisao),
            render(text, record, index) {
                return <>{tratarValoresBoolean(record.verbaRemanescenteProvisao)} </>;
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar VRP"
                            name="verbaRemanescenteProvisao"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.verbaRemanescenteProvisao !== undefined &&
                record.verbaRemanescenteProvisao
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'DESCONSIDERAR EXECUTADO',
            dataIndex: 'desconsiderarRelatorioAno',
            width: larguraDesconsiderarExecutado,
            sorter: (a, b) => compareBool(a.desconsiderarRelatorioAno, b.desconsiderarRelatorioAno),
            align: 'center',
            render(text, record, index) {
                return <>{tratarValoresBoolean(record.desconsiderarRelatorioAno)} </>;
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar DESCONSIDERAR EXECUTADO"
                            name="desconsiderarRelatorioAno"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.desconsiderarRelatorioAno !== undefined &&
                record.desconsiderarRelatorioAno
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'MOTIVO',
            dataIndex: 'motivo',
            width: larguraMotivo,
            sorter: (a, b) => compareText(a.motivo, b.motivo),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar MOTIVO"
                            name="motivo"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.motivo !== undefined &&
                record.motivo
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        }
    ];

    const tratarValoresBoolean = (valor: boolean) => {
        return valor === false ? 'Inativo' : 'Ativo';
    };

    return (
        (result) ? (
            <Table
                id={`tabela_executado_${tabelaId}`}
                columns={columnsProcessado}
                dataSource={result}
                scroll={{ x: larguraTotal() }}
            />

        ) : (<> </>)
    );
};

export default TabelaExecutadoMesAno;
